var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditChargerDialog',{attrs:{"charger":_vm.charger},on:{"saved":function($event){return _vm.$emit('saved', $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('a',_vm._g(_vm._b({attrs:{"title":"Edit Charger Settings"}},'a',attrs,false),on),[_vm._v(_vm._s(_vm.charger.displayName))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }